import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { useMutation } from "@tanstack/react-query";

import { deleteTask } from "../../api/tasksAPI";
import { queryClient } from "../../api/requestProcessor";
import { useContext } from "react";
import { AppContext } from "../../context/AppProvider";
import { getErrorMessage } from "../../util/helper";

export default function DeleteTask({
  deleteTaskDialog,
  hideDeleteTaskDialog,
  task,
}) {
  const { toast } = useContext(AppContext);
  const { mutate, isPending } = useMutation({
    mutationFn: deleteTask,
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ["tasks"] });
      hideDeleteTaskDialog();
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: response.message,
        life: 3000,
      });
    },
    onError: (error) => {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: getErrorMessage(error),
        life: 3000,
      });
    },
  });

  const handleDeleteTask = () => {
    mutate({ taskId: task._id });
  };

  const deleteProductDialogFooter = (
    <>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteTaskDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={handleDeleteTask}
        loading={isPending}
      />
    </>
  );

  return (
    <Dialog
      visible={deleteTaskDialog}
      style={{ width: "32rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header="Confirm"
      modal
      footer={deleteProductDialogFooter}
      onHide={hideDeleteTaskDialog}
      className="mx-2"
    >
      <div className="confirmation-content">
        <i
          className="pi pi-exclamation-triangle mr-3"
          style={{ fontSize: "2rem" }}
        />
        {task && (
          <span>
            Are you sure you want to delete <b>{task.subject}</b>?
          </span>
        )}
      </div>
    </Dialog>
  );
}
